import { render, staticRenderFns } from "./ClientStatusCard.vue?vue&type=template&id=74cc4028"
import script from "./ClientStatusCard.vue?vue&type=script&lang=js"
export * from "./ClientStatusCard.vue?vue&type=script&lang=js"
import style0 from "./ClientStatusCard.vue?vue&type=style&index=0&id=74cc4028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports